import { LinearProgress, Box } from "@mui/material";

interface Props {
  isLoading: boolean;
}

const SbuxLoadingIndicator = ({ isLoading }: Props) => {
  if (!isLoading) return null;
  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgress color="primary" />
    </Box>
  );
};

export default SbuxLoadingIndicator;
